import React from "react";
import { TableHead, TableRow, TableCell } from "@mui/material";
import { TableSortLabel } from "@mui/material";
import { COLUMNS } from "./constants";
import { tableConfigAtom } from "../../atoms/bookingsTable";
import { useAtom } from "jotai";
import { isMbxUserVerifiedStaff } from "../../atoms/atoms";

export const BookingsTableHead = () => {
    const [tableConfig, setTableConfig] = useAtom(tableConfigAtom);
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);

    const filteredColumns = COLUMNS.filter((column) => {
        // Only include the 'provider' column if the user logged in as a verified staff (Admin or Manager)
        return column.key !== "provider" || isVerifiedStaff;
    });

    const {
        sort: { sortBy, direction }
    } = tableConfig;

    return (
        <TableHead>
            <TableRow>
                {filteredColumns.map(({ key, label, sortable }) => {
                    if (key === "total" && !isVerifiedStaff) {
                        return null;
                    }

                    return (
                        <TableCell
                            key={key}
                            sx={{
                                textAlign:
                                    key === "status" || key === "notes"
                                        ? "center"
                                        : key === "total"
                                          ? "right"
                                          : "left"
                            }}
                        >
                            {sortable ? (
                                <TableSortLabel
                                    active={sortBy === key}
                                    direction={direction?.toLowerCase()}
                                    onClick={() =>
                                        setTableConfig({
                                            ...tableConfig,
                                            sort: {
                                                sortBy: key,
                                                direction:
                                                    direction === "ASC"
                                                        ? "DESC"
                                                        : "ASC"
                                            }
                                        })
                                    }
                                >
                                    {label}
                                </TableSortLabel>
                            ) : (
                                label
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};
